module.exports = __webpack_public_path__ + "static/AIR-JARVIS-dc847688a2b893a2585f345efe915142.png";